import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Logo from "../../../assets/images/logo.png";
import SmallLogo from "../../../assets/images/small-logo.png";
import {
  FaStore,
  FaBox,
  FaUsers,
  FaShoppingCart,
  FaClipboardCheck,
  FaChartLine,
  FaBell,
  FaCog,
  FaMapMarkedAlt,
  FaUserShield,
  FaFileInvoice,
  FaUserCircle,
  FaTruck,
  FaWpforms,
  FaFileAlt,
  FaLayerGroup,
  FaTags,
  FaChevronDown,
  FaTools,
  FaLock,
  FaSyncAlt,
  FaBoxOpen,
  FaBriefcase,
  FaChevronLeft,
  FaChevronRight,
  FaImage,
  FaList,
  FaGavel,
  FaHistory,
  FaHeadset,
  FaRegCreditCard,
  FaInfoCircle,
  FaExternalLinkAlt,
  FaStripe,
  FaSms,
  FaEnvelope,
  FaCloud,
  FaMapMarkerAlt,
  FaGlobe
} from "react-icons/fa";

/* ---------- SINGLE MENU ITEM ---------- */
const SidebarItem = ({ icon, label, to, collapsed }) => (
  <NavLink
    to={to}
    className={({ isActive }) =>
      `flex items-center gap-3 px-4 py-3 rounded-full transition-all duration-300 ${
        isActive
          ? "bg-[#8a3dbd] text-white font-semibold"
          : "text-gray-600 hover:bg-[#8a3dbd] hover:text-white"
      }`
    }
  >
    <span className="text-lg">{icon}</span>
    {!collapsed && <span className="text-sm">{label}</span>}
  </NavLink>
);

/* ---------- PRODUCT DROPDOWN ---------- */
const ProductManageDropdown = ({ collapsed }) => {
  const [open, setOpen] = React.useState(false);

  return (
    <div>
      <div
        onClick={() => setOpen(!open)}
        className="flex items-center justify-between px-4 py-3 rounded-lg cursor-pointer text-gray-600 hover:bg-[#ffc933]"
      >
        <div className="flex items-center gap-3">
          <FaBox className="text-lg" />
          {!collapsed && <span className="text-sm">Product Manage</span>}
        </div>
        {!collapsed && (
          <FaChevronDown className={`transition-transform ${open ? "rotate-180" : ""}`} />
        )}
      </div>

      {open && !collapsed && (
        <div className="pl-6 mt-1 ml-6 space-y-1">
          <NavLink to="/admin/services" className="flex items-center gap-2 text-sm text-gray-600 hover:text-[#6a0dad] py-2">
            <FaTools className="text-sm" /> Services
          </NavLink>
          <NavLink to="/admin/variants" className="flex items-center gap-2 text-sm text-gray-600 hover:text-[#6a0dad] py-2">
            <FaLayerGroup className="text-sm" /> Variants
          </NavLink>
          <NavLink to="/admin/products" className="flex items-center gap-2 text-sm text-gray-600 hover:text-[#6a0dad] py-2">
            <FaBoxOpen className="text-sm" /> Products
          </NavLink>
          <NavLink to="/admin/coupons" className="flex items-center gap-2 text-sm text-gray-600 hover:text-[#6a0dad] py-2">
            <FaTags className="text-sm" /> Coupon
          </NavLink>
        </div>
      )}
    </div>
  );
};

/* ---------- REPORT DROPDOWN ---------- */
const ReportDropdown = ({ collapsed }) => {
  const [openSub, setOpenSub] = React.useState(false);

  return (
    <div>
      <div
        onClick={() => setOpenSub(!openSub)}
        className="flex items-center justify-between px-4 py-3 rounded-lg cursor-pointer text-gray-600 hover:bg-[#ffc933]"
      >
        <div className="flex items-center gap-3">
          <FaFileAlt className="text-lg" />
          {!collapsed && <span className="text-sm">Report</span>}
        </div>
        {!collapsed && (
          <FaChevronDown className={`transition-transform ${openSub ? "rotate-180" : ""}`} />
        )}
      </div>

      {openSub && !collapsed && (
        <div className="pl-6 mt-1 ml-6 space-y-1">
          <NavLink to="/admin/shop-list" className="flex items-center gap-2 text-sm text-gray-600 hover:text-[#6a0dad] py-2">
            <FaClipboardCheck className="text-sm" /> Shop List
          </NavLink>
          <NavLink to="/admin/revenue" className="flex items-center gap-2 text-sm text-gray-600 hover:text-[#6a0dad] py-2">
            <FaBriefcase className="text-sm" /> Revenue
          </NavLink>
        </div>
      )}
    </div>
  );
};


/* ---------- SETTINGS DROPDOWN ---------- */
const SettingsDropdown = ({ collapsed }) => {
  const [openSub, setOpenSub] = React.useState(false);

  return (
    <div>
      <div
        onClick={() => setOpenSub(!openSub)}
        className="flex items-center justify-between px-4 py-3 rounded-lg cursor-pointer text-gray-600 hover:bg-[#ffc933]"
      >
        <div className="flex items-center gap-3">
          <FaCog className="text-lg" />
          {!collapsed && <span className="text-sm">Settings</span>}
        </div>
        {!collapsed && (
          <FaChevronDown className={`transition-transform ${openSub ? "rotate-180" : ""}`} />
        )}
      </div>

      {openSub && !collapsed && (
        <div className="pl-6 mt-1 ml-6 space-y-1">
          <NavLink to="/admin/privacy-policy" className="flex items-center gap-2 text-sm text-gray-600 hover:text-[#6a0dad] py-2">
            <FaLock  className="text-sm" /> Privacy Policy
          </NavLink>
          <NavLink to="/admin/terms-services" className="flex items-center gap-2 text-sm text-gray-600 hover:text-[#6a0dad] py-2">
            <FaGavel className="text-sm" /> Terms of Services
          </NavLink>
          {/* <NavLink to="/admin/contact-us" className="flex items-center gap-2 text-sm text-gray-600 hover:text-[#6a0dad] py-2">
            <FaHeadset className="text-sm" /> Contact Us
          </NavLink> */}
          <NavLink to="/admin/about-us" className="flex items-center gap-2 text-sm text-gray-600 hover:text-[#6a0dad] py-2">
            <FaInfoCircle className="text-sm" /> About Us
          </NavLink>
          <NavLink to="/admin/payment-gateway" className="flex items-center gap-2 text-sm text-gray-600 hover:text-[#6a0dad] py-2">
            <FaRegCreditCard className="text-sm" /> Payment Gateway
          </NavLink>
          <NavLink to="/admin/app-settings" className="flex items-center gap-2 text-sm text-gray-600 hover:text-[#6a0dad] py-2">
            <FaCog className="text-sm" /> App Settings
          </NavLink>
        </div>
      )}
    </div>
  );
};

/* ---------- MAIN SIDEBAR ---------- */
const Sidebar = ({ collapsed, setCollapsed }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear(); // remove admin session
    navigate("/admin/login");
  };

  return (
    <aside
      className={`fixed top-0 left-0 h-screen bg-white border-r transition-all duration-300 flex flex-col
      ${collapsed ? "w-20" : "w-64"}`}
    >
      {/* LOGO + TOGGLE */}
      <div className="relative flex items-center justify-center p-4 border-b bg-[#8a3dbd]">
        <img
          src={collapsed ? SmallLogo : Logo}
          alt="Logo"
          className="object-contain h-10"
        />

        <button
          onClick={() => setCollapsed(!collapsed)}
          className="absolute -right-3 top-14 bg-white border shadow-md rounded-full w-8 h-8 flex items-center justify-center text-[#6a0dad] hover:bg-[#8a3dbd] hover:text-white transition"
        >
          {collapsed ? <FaChevronRight /> : <FaChevronLeft />}
        </button>
      </div>

      {/* MENU */}
      <nav className="flex-1 p-3 space-y-1 overflow-y-auto">
        {/* <SidebarItem icon={<FaChartLine />} label="Dashboard" to="/admin/dashboard" collapsed={collapsed} />
        <SidebarItem icon={<FaShoppingCart />} label="Orders" to="/admin/orders" collapsed={collapsed} />
        <ProductManageDropdown collapsed={collapsed} />
        <SidebarItem icon={<FaBell />} label="Notifications" to="/admin/notifications" collapsed={collapsed} /> */}
        {/*<SubscriptionDropdown collapsed={collapsed} />*/}
        {/* <ReportDropdown collapsed={collapsed} />
        <SidebarItem icon={<FaImage />} label="App Banners" to="/admin/app-banners" collapsed={collapsed} />
        <SidebarItem icon={<FaUsers />} label="Customer" to="/admin/customers" collapsed={collapsed} />
        <SidebarItem icon={<FaTruck />} label="Drivers" to="/admin/drivers" collapsed={collapsed} /> */}
        {/*<SidebarItem icon={<FaMapMarkedAlt />} label="Stores in map" to="/admin/stores-map" collapsed={collapsed} />*/}
        {/* <SettingsDropdown collapsed={collapsed} />
        <SidebarItem icon={<FaStore />} label="Shops" to="/admin/shops" collapsed={collapsed} />
        <SidebarItem icon={<FaUserShield />} label="Admins" to="/admin/alladmins" collapsed={collapsed} /> */}
        {/*<ThirdPartyConfigDropdown collapsed={collapsed} />*/}
        {/* <SidebarItem icon={<FaFileInvoice />} label="Invoice Manage" to="/admin/invoice" collapsed={collapsed} />
        <SidebarItem icon={<FaUserCircle />} label="Profile" to="/admin/profile" collapsed={collapsed} /> */}
        {/*<SidebarItem icon={<FaGlobe />} label="Languages" to="/admin/languages" collapsed={collapsed} />*/}
        <SidebarItem icon={<FaWpforms />} label="Vendor Form" to="/admin/vendor-form" collapsed={collapsed} />
        <SidebarItem icon={<FaEnvelope />} label="Contact Us" to="/admin/contact-us" collapsed={collapsed} />
        <div
          onClick={handleLogout}
          className="flex items-center gap-3 px-4 py-3 mt-4 transition rounded-full text-gray-600 cursor-pointer hover:bg-[#8a3dbd] hover:text-white">
          <FaLock className="text-lg" />
          {!collapsed && <span className="text-sm font-medium">Logout</span>}
        </div>
      </nav>
    </aside>
  );
};

export default Sidebar;
